import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PatchPasswordUser(idUser, idRequest, password) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}user/resetpassword/${idUser}`;

      const userPasswordPatch = {
        ResetPasswordRequest: idRequest,
        Password: password,
        ModifiedBy: 'ea1e3cb5-8b39-4f3b-a938-b9070d9d9746',
      };
      
    const response = await axios.patch(req, userPasswordPatch, apiConfig.HEADERS_CONFIG,{
      });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
